const slideToggles = document.querySelectorAll<HTMLButtonElement>(
  '.js-slide-toggle-btn'
);

function onToggleClick(this: HTMLButtonElement) {
  const { container, hideLabel, showLabel } = this.dataset;

  if (!container || !hideLabel || !showLabel) return;

  const containerEl = document.querySelector<HTMLElement>(container);
  if (!containerEl) return;

  if (!containerEl.classList.contains('is-active')) {
    containerEl.classList.add('is-active');
    containerEl.style.height = 'auto';
    this.innerHTML = hideLabel;
    const height = containerEl.clientHeight + 'px';
    containerEl.style.height = '150px';

    setTimeout(() => {
      containerEl.style.height = height;
    }, 0);
  } else {
    containerEl.style.height = '150px';
    this.innerHTML = showLabel;
    containerEl.addEventListener(
      'transitionend',
      () => {
        containerEl.classList.remove('is-active');
      },
      { once: true }
    );
  }
}

slideToggles.forEach((toggleBtn) => {
  toggleBtn.addEventListener('click', onToggleClick);
});
